import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useRepliesContext } from "store/contexts/repliesContext";
import { CSSTransition } from "react-transition-group";
import * as moment from "moment";
import Loader from "components/Loader";
import { useUserContext } from "store/contexts/userContext";
import ReactionDailogue from "../ReactionDailogue";
import { useTimelineContext } from "store/contexts/timelineContext";

function ReplyMessage({ listTask, reply }) {
  const [showReactions, setShowReaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateReply } = useRepliesContext();
  const { user } = useUserContext();
  const [dialogState, setDialogState] = useState(false);
  const { setHide } = useTimelineContext();
  const moreReaction = {
    display: "flex",
    justifyContent: "center",
    color: "rgb(0 0 0 / 75%)",
    fontWeight: "400",
    padding: "5px 10px",
  };

  const showReactionUserList = async (event) => {
    setShowReaction(event.currentTarget);

    if (!reply.reactions) {
      setLoading(true);

      await getReactionDetails();
    }
  };

  const getReactionDetails = async () => {
    try {
      const response = await TeamService.getListCommentBuzzlist(
        listTask?.post?.team_id,
        listTask?.id,
        reply?.id
      );

      updateReply({
        ...reply,
        reactions: response?.data?.data,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const hideReactionUserList = () => {
    setShowReaction(null);
  };

  const showDailogue = () => {
    setShowReaction(null);
    setDialogState(true);
    setHide(true);
  };

  return (
    <>
      <div
        onMouseEnter={showReactionUserList}
        onMouseLeave={hideReactionUserList}
        onClick={showDailogue}
        className="comment-footer-message"
      >
        {reply?.buzzes_count > 0 && (
          <img
            src={
              (reply?.buzz_type_id === null
                ? reply?.recent_buzz_activity_user?.avatar
                : user?.avatar) ?? userAvatar
            }
            alt={`${reply?.recent_buzz_activity_user?.full_name}`}
            className="buzzUserImage"
          />
        )}
        {Boolean(reply?.buzzes_count) && `${reply?.buzzes_count} reacted`}
        {Boolean(reply?.buzzes_count) && Boolean(reply?.replies_count) && ", "}
        {Boolean(reply?.replies_count) &&
          `${reply?.replies_count} ${
            reply?.replies_count > 1 ? "replies" : "reply"
          }`}
        <CSSTransition
          in={Boolean(showReactions)}
          timeout={300}
          unmountOnExit
          classNames="dropdown-element"
        >
          <div className="reactionListContent reactionsCommentContent">
            <div className="reactionListContainer">
              {loading && <Loader width={40} height={40} />}
              <div>
                {reply?.reactions &&
                  reply?.reactions?.slice(0, 5).map((response, index) => (
                    <ul key={index} className="displayReactionList">
                      <li key={response.id} className="displayReactionList">
                        <p className="muiListItem">
                          <span className="displayReactionName">
                            <span>
                              {response?.user?.id === user?.id
                                ? "You Reacted At "
                                : response?.user?.full_name}
                            </span>
                            <span className="displayDate">
                              {moment(response?.user?.responded_at).format(
                                "MMM DD, YYYY"
                              )}
                            </span>
                          </span>
                        </p>
                      </li>
                    </ul>
                  ))}
                {reply?.buzzes_count > 5 && (
                  <div style={moreReaction}>
                    <span>and {reply?.buzzes_count} more</span>
                  </div>
                )}
              </div>
              {reply.reactions && reply.reactions.length === 0 && !loading && (
                <div style={moreReaction}>No Reaction</div>
              )}
            </div>
          </div>
        </CSSTransition>
      </div>
      {reply?.reactions?.length !== 0 && !loading && (
        <ReactionDailogue
          loading={loading}
          listTask={reply}
          dialogState={dialogState}
          setDialogState={setDialogState}
        />
      )}
    </>
  );
}

export default ReplyMessage;
